import { useState } from 'react';
import {
  formatDate,
  formatTimeRange,
} from '@purple-start-registration/common/dates';
import { strings } from '@purple-start-registration/common/localization';

import { formatHTML } from '../../../common/price';

function findPreviousAvailable(list, index, total) {
  const selection = [];

  for (let counter = index; counter >= 0; counter = counter - 1) {
    if (!list[counter].full) {
      selection.push(counter);
    }

    if (selection.length === total) {
      return selection;
    }
  }

  return selection;
}

function findNextAvailable(list, index, total) {
  const selection = [];

  for (let counter = index; counter < list.length; counter = counter + 1) {
    if (!list[counter].full) {
      selection.push(counter);
    }

    if (selection.length === total) {
      return selection;
    }
  }

  return selection;
}

export function SelectionTrial({ config, language, onChange }) {
  const { settings, sessions } = config;

  const [checkedState, setCheckedState] = useState(
    new Array(sessions.length).fill(false)
  );

  const toggleSelection = (selectedPositions) => {
    const updatedState = checkedState.map((_, index) => {
      return selectedPositions.indexOf(index) >= 0;
    });
    setCheckedState(updatedState);
  };

  const notifyParent = (selectedPositions) => {
    if (onChange) {
      onChange(selectedPositions.map((position) => sessions[position]));
    }
  };

  const handleOnChange = (position) => {
    const selectedPositions = [];
    if (position === checkedState.length - 1) {
      const previousAvailable = findPreviousAvailable(
        sessions,
        position,
        settings.trial_sessions
      );
      selectedPositions.push(...previousAvailable);
    } else {
      const nextAvailable = findNextAvailable(
        sessions,
        position,
        settings.trial_sessions
      );
      selectedPositions.push(...nextAvailable);
    }

    toggleSelection(selectedPositions);
    notifyParent(selectedPositions);
  };

  return (
    <fieldset>
      <div>
        <legend
          className="text-base font-medium text-gray-900"
          dangerouslySetInnerHTML={{
            __html: strings.formatString(
              strings.sessionsByTrialTitle,
              settings.trial_sessions
            ),
          }}
        />
        <p
          className="mt-1 text-sm text-gray-700"
          dangerouslySetInnerHTML={{
            __html:
              strings.formatString(
                strings.sessionsByTrialDescription,
                formatHTML(settings.trial_sessions * settings.trial_price)
              ) +
              ((settings.trial_sessions > 1 &&
                ' ' +
                  strings.formatString(
                    strings.sessionsByTrialDescriptionDates,
                    settings.trial_sessions
                  )) ||
                ''),
          }}
        />
      </div>
      <div className="mt-4 space-y-4">
        {sessions.map((session, index) => (
          <div key={session.dateISO} className="relative flex items-start">
            <div className="flex items-center h-5">
              <input
                id={session.dateISO}
                type="checkbox"
                name={session.dateISO}
                checked={checkedState[index]}
                disabled={session.full}
                className="focus:ring-purple-500 h-4 w-4 text-purple-600 border-gray-300 rounded"
                onChange={() => handleOnChange(index)}
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor={session.dateISO} className="text-gray-700">
                {(session.full && (
                  <span className="text-gray-500">
                    {formatDate(session.date, language)}&nbsp;
                    <span className="text-gray-400">
                      ({strings.fullyBooked})
                    </span>
                  </span>
                )) || (
                  <>
                    {formatDate(session.date, language)}&nbsp;
                    <span>
                      (
                      <strong>
                        {formatTimeRange(session.start, session.end, language)}
                      </strong>
                      )
                    </span>
                  </>
                )}
              </label>
            </div>
          </div>
        ))}
      </div>
    </fieldset>
  );
}
